import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { setCandidate } from 'src/app/actions/candidate.actions';
import { setQuestion } from 'src/app/actions/question.actions';
import { setTest } from 'src/app/actions/test.actions';
import { Candidate } from 'src/app/models/candidate.model';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { QuestionService } from 'src/app/services/question.service';
import { TestService } from 'src/app/services/test.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements AfterViewInit {

  public question$: Observable<Question>;
  private token: string;
  languageID: number;
  public showTerms = false;
  candidate: Candidate;
  statusFinalized = ['expired', 'completed'];
  currentTest: Test;

  private computedBodyStyle = getComputedStyle(document.body)

  public colors = {
    primaryColor: this.computedBodyStyle.getPropertyValue('--color-primary'),
    secondaryColor: this.computedBodyStyle.getPropertyValue('--color-secondary'),
    tertiaryColor: this.computedBodyStyle.getPropertyValue('--color-tertiary'),
    quaternaryColor: this.computedBodyStyle.getPropertyValue('--color-quaternary'),
    quinaryColor: this.computedBodyStyle.getPropertyValue('--color-quinary'),
    senaryColor: this.computedBodyStyle.getPropertyValue('--color-senary'),
    septenaryColor: this.computedBodyStyle.getPropertyValue('--color-septenary'),
    octonaryColor: this.computedBodyStyle.getPropertyValue('--color-octonary'),
    nonaryColor: this.computedBodyStyle.getPropertyValue('--color-nonary')
  }

  constructor(
    private questionService: QuestionService,
    private store: Store,
    public utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
    private testService: TestService,
    private translateService: TranslateService,
    private router: Router
  ) { }

  ngAfterViewInit(): void {
    // obtenemos el valor de la pregunta actual del test
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    // obtenemos el token del test
    this.token = this.activatedRoute.snapshot.paramMap.get('token');

    // obtenemos los datos del test y los seteamos en la store
    this.testService.getTestByToken(this.token).subscribe(test => {
      this.currentTest = test;
      this.store.dispatch(setTest(test));
      this.store.dispatch(setCandidate(test.candidate));
      this.candidate = test.candidate;

      // Evaluamos la propiedad de aceptar términos
      this.acceptedTermsCheck(test);

      if (test.invitation?.project && test.invitation?.project.id) {

        this.colors = {
          primaryColor: test.invitation.project.primaryColor,
          secondaryColor: test.invitation.project.secondaryColor,
          tertiaryColor: test.invitation.project.tertiaryColor,
          quaternaryColor: test.invitation.project.quaternaryColor,
          quinaryColor: test.invitation.project.quinaryColor,
          senaryColor: test.invitation.project.senaryColor,
          septenaryColor: test.invitation.project.septenaryColor,
          octonaryColor: test.invitation.project.octonaryColor,
          nonaryColor: test.invitation.project.nonaryColor
        }

        document.getElementById('candidateModule').style.setProperty('--color-primary', this.colors.primaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-secondary', this.colors.secondaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-tertiary', this.colors.tertiaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-quaternary', this.colors.quaternaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-quinary', this.colors.quinaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-senary', this.colors.senaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-septenary', this.colors.septenaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-octonary', this.colors.octonaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-nonary', this.colors.nonaryColor);
      }

      // seteamos al idioma de la invitación
      this.translateService.use(this.utilsService.getLanguageFromLanguageId(test.invitation.languageId));
      document.documentElement.lang = this.utilsService.getLanguageFromLanguageId(test.invitation.languageId).split('-')[0];

      // inyectamos el valor del idioma en los terminos legales
      this.languageID = test.invitation.languageId;
    });

    // obtenemos la siguiente pregunta del test (instrucciones seguramente)
    this.questionService.getNextQuestion(this.token, true).subscribe(question => {
      this.store.dispatch(setQuestion(question));
    });
  }

  // aceptamos los terminos legales sino no se aceptaron previamente.
  postAcceptTerms() {
    if (this.showTerms) {
      if (!this.candidate.acceptTerms) {
        this.testService.putAcceptTerms(this.candidate.invitations[0].token).subscribe(result => {
          this.candidate = result;
          this.showTerms = false;
        });
      }
    }
  }

  // comprobación de si de deben mostrar los términos y condiciones
  acceptedTermsCheck(test: Test) {
    // comprobamos que no esté caducado o finalizado
    if (!this.statusFinalized.includes(test.status)) {
      // comprobamos que no venga de eureka
      if (this.candidate.origin === 'web') {
        this.showTerms = false;
      } else {
        // revisamos si ya los aceptó
        if (!test.candidate?.acceptTerms) {
          this.showTerms = true;
        }
      }
    }
  }
}
